
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1024","height":"1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M874.21 149.802c-199.778-199.736-524.674-199.736-724.452 0-199.692 199.736-199.692 524.716 0 724.451C249.647 974.102 380.825 1024 512.004 1024c131.183 0 262.315-49.903 362.206-149.747 199.735-199.735 199.735-524.715 0-724.451zM723.264 662.95c16.691 16.687 16.691 43.669 0 60.356-8.324 8.324-19.251 12.51-30.178 12.51s-21.858-4.186-30.182-12.51L512.005 572.364 361.147 723.263c-8.366 8.324-19.296 12.51-30.181 12.51-10.927 0-21.857-4.186-30.181-12.51-16.69-16.691-16.69-43.712 0-60.361l150.86-150.899-150.901-150.899c-16.69-16.69-16.69-43.712 0-60.36 16.648-16.69 43.669-16.69 60.36 0l150.898 150.898 150.903-150.898c16.687-16.69 43.669-16.69 60.356 0 16.691 16.648 16.691 43.669 0 60.36L572.362 512.003l150.903 150.946z"}})])
          )
        }
      }
    